import { SharedStoreStatic, CustomActionType } from "./SharedStoreStatic";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../react-core/Flux/Dispatcher";

export interface FluxResponse {
    actionType: CustomActionType | ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const SharedDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const SharedStore: SharedStoreStatic = new SharedStoreStatic();
